<template>
  <fragment>
    <AppBody
      title="Relatórios Sintéticos"
      subtitle="Relatório de Recebíveis"
      :actions="actions"
      :primaryLoading="$relatorios_sinteticos.loading_button_export_csv"
      :secondaryLoading="$relatorios_sinteticos.loading_button_export_pdf"
      disableDivider
    >
      <CardModule untitle>
        <v-form @submit.prevent="filterRecebiveis" class="search-forms">
          <v-row>
            <v-col cols="12" sm="3">
              <BaseSelect
                label="Tipo de Pessoa"
                :items="$relatorios_sinteticos.tipo_pessoa"
                item-text="text"
                item-value="value"
                v-model="$relatorios_sinteticos.filter_recebimentos.tipo_pessoa"
                placeholder="Selecione o tipo de pessoa"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="
                $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                'idponto_venda'
              "
            >
              <template
                v-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idagente'
                "
              >
                <BaseAutocomplete
                  label="Agente"
                  v-model="$relatorios_sinteticos.filter_recebimentos.pessoa"
                  :items="$pessoas_agentes.agentes"
                  placeholder="Selecione o Agente"
                  :filter="search"
                  chips
                  color="blue-grey lighten-2"
                  item-text="representante_nome"
                  item-value="idagente"
                  no-data-text="Nenhum agente encontrado"
                  clearable
                  @click:clear="
                    $relatorios_sinteticos.clearFilterFields(
                      'recebimento_pessoa'
                    )
                  "
                >
                  <template v-slot:selection="{ item }">
                    {{ item.representante_nome }}
                  </template>
                  ></BaseAutocomplete
                >
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                    'idponto_venda' || !isAdmin
                "
              >
                <BaseAutocomplete
                  v-model="$relatorios_sinteticos.filter_recebimentos.pessoa"
                  label="Ponto de Venda"
                  :items="$pointOfSale.pontos_de_venda"
                  placeholder="Selecione o Ponto de Venda"
                  :filter="search"
                  chips
                  color="blue-grey lighten-2"
                  item-text="representante_nome"
                  item-value="idponto_venda"
                  no-data-text="Nenhum ponto de venda encontrado"
                  clearable
                  @click:clear="
                    $relatorios_sinteticos.clearFilterFields(
                      'recebimento_pessoa'
                    )
                  "
                >
                  <template v-slot:selection="{ item }">
                    {{ item.representante_nome }}
                  </template>
                  ></BaseAutocomplete
                >
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                    '' ||
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa == null
                "
              >
                <BaseSelect
                  label="Pessoa"
                  disabled
                  placeholder="Selecione a pessoa"
                />
              </template>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <BaseSelect
                label="Intervalo de Datas"
                :items="$relatorios_sinteticos.intervalo_data"
                item-text="text"
                item-value="value"
                v-model="
                  $relatorios_sinteticos.filter_recebimentos.intervalo_datas
                "
                placeholder="Selecione o intervalo de datas"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              sm="4"
              v-if="
                $relatorios_sinteticos.filter_recebimentos.intervalo_datas !=
                'custom'
              "
            >
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_sinteticos.filter_recebimentos
                        .intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    @click:clear="
                      $relatorios_sinteticos.clearFilterFields(
                        'recebimento_pessoa_dates'
                      )
                    "
                  />
                </template>
                <v-date-picker
                  v-model="computeRange"
                  :active-picker.sync="activePicker"
                  @change="computeRange"
                  locale="pt"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  @input="menu = false"
                  range
                  @click:month="monthEvent"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" sm="4" v-else>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <BaseTextField
                    label="Datas"
                    v-model="dateRangeText"
                    :append-icon="$config.icons.calendar"
                    readonly
                    :disabled="
                      $relatorios_sinteticos.filter_recebimentos
                        .intervalo_datas != null
                        ? false
                        : true
                    "
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="
                      $relatorios_sinteticos.filter_recebimentos.error
                        .range_dates
                    "
                    @input="
                      $relatorios_sinteticos.filter_recebimentos.error.range_dates =
                        []
                    "
                    :placeholder="placeholderData"
                    :color="$config.dados.corinputs"
                    clearable
                    @click:clear="
                      $relatorios_sinteticos.clearFilterFields(
                        'recebimento_pessoa_dates'
                      )
                    "
                  />
                </template>
                <v-date-picker
                  v-model="
                    $relatorios_sinteticos.filter_recebimentos.range_dates
                  "
                  :active-picker.sync="activePicker"
                  locale="pt"
                  :header-color="$config.dados.corinputs"
                  :color="$config.dados.corinputs"
                  @input="
                    $relatorios_sinteticos.filter_recebimentos.range_dates
                      .length == 2
                      ? (menu = false)
                      : (menu = true)
                  "
                  range
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="d-flex justify-end" v-if="!isAdmin">
              <BaseButton
                type="submit"
                :loading="$relatorios_sinteticos.loading_button"
                tabindex="13"
                variant="filter"
                class="button rounded-xxl"
              >
                Filtrar
              </BaseButton>
            </v-col>
            <v-col class="d-flex justify-end" v-if="isAdmin">
              <BaseButton
                type="submit"
                :loading="$relatorios_sinteticos.loading_button"
                tabindex="13"
                variant="filter"
                class="button rounded-xxl"
              >
                Filtrar
              </BaseButton>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="relatorios-container11 my-3 px-3">
          <v-col class="resumo-container rounded-xl">
            <div class="resumo-stat">
              <template
                v-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idloja'
                "
              >
                <span class="resumo-text">Saldo Disponível</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos.saldo_disponivel
                      | moeda
                  }}
                </h1>
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idagente'
                "
              >
                <span class="resumo-text">Saldo disponível para saque</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos.saldo_disponivel
                      | moeda
                  }}
                </h1>
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idponto_venda'
                "
              >
                <span class="resumo-text">Saldo disponível para saque</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos.saldo_disponivel
                      | moeda
                  }}
                </h1>
              </template>
            </div>
          </v-col>
          <v-col class="resumo-container rounded-xl">
            <div class="resumo-stat">
              <template
                v-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idloja'
                "
              >
                <span class="resumo-text">Aguardando Liberação</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos
                      .aguardando_liberacao | moeda
                  }}
                </h1>
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idagente'
                "
              >
                <span class="resumo-text">Saldo aguardando liberação</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos
                      .aguardando_liberacao | moeda
                  }}
                </h1>
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idponto_venda'
                "
              >
                <span class="resumo-text">Saldo aguardando liberação</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos
                      .aguardando_liberacao | moeda
                  }}
                </h1>
              </template>
            </div>
          </v-col>
          <v-col class="resumo-container rounded-xl">
            <div class="resumo-stat">
              <template
                v-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idloja'
                "
              >
                <span class="resumo-text">Valor total a Receber</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos.total_comissao
                      | moeda
                  }}
                </h1>
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idagente'
                "
              >
                <span class="resumo-text">Total de comissões</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos.total_comissao
                      | moeda
                  }}
                </h1>
              </template>
              <template
                v-else-if="
                  $relatorios_sinteticos.filter_recebimentos.tipo_pessoa ==
                  'idponto_venda'
                "
              >
                <span class="resumo-text">Total de comissões</span>
                <v-progress-circular
                  :size="70"
                  :color="$config.dados.corinputs"
                  indeterminate
                  v-if="
                    $relatorios_sinteticos.filter_recebimentos.loading.saldos
                  "
                ></v-progress-circular>
                <h1 class="resumo-valor" v-else>
                  {{
                    $relatorios_sinteticos.resumo_recebimentos.total_comissao
                      | moeda
                  }}
                </h1>
              </template>
            </div>
          </v-col>
        </v-row>
        <v-data-table
          class="table-body"
          no-data-text="Não há registro de recebimentos."
          loading-text="Buscando informações..."
          :loading="
            $relatorios_sinteticos.filter_recebimentos.loading
              .recebimentos_listagem
          "
          :headers="headers"
          :items="tableValues"
          :items-per-page="10"
          :custom-sort="$relatorios_sinteticos.customSort"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: 'Recebimentos por página:',
          }"
        >
          <template v-slot:item.dt_pedido="{ item }">
            {{ item.dthr_pedido | dthr_pt_br }}
          </template>
          <template v-slot:item.valor="{ item }">
            {{ item.valor | moeda }}
          </template>
          <template v-slot:item.valor_juros="{ item }">
            {{ item.valor_juros | moeda }}
          </template>
          <template v-slot:item.valor_total="{ item }">
            {{ item.valor_total | moeda }}
          </template>
          <template v-slot:item.comissao="{ item }">
            {{ item.comissao | moeda }}
          </template>
          <template v-slot:item.valor_cancelado="{ item }">
            {{ item.valor_cancelado | moeda }}
          </template>
          <template v-slot:item.taxa_processamento="{ item }">
            {{ item.taxa_processamento | moeda }}
          </template>
          <template v-slot:item.taxa_conveniencia="{ item }">
            {{ item.taxa_conveniencia | moeda }}
          </template>
        </v-data-table>
        <v-data-table
          class="table-totals-body"
          hide-default-footer
          no-data-text="Não há registro de recebimentos."
          loading-text="Buscando informações..."
          :loading="$relatorios_sinteticos.filter_recebimentos.loading.totais"
          :headers="headersTotais"
          :items="totalTableValues"
        >
          <template v-slot:item.valor="{ item }">
            {{ item.valor | moeda }}
          </template>
          <template v-slot:item.taxa_conveniencia="{ item }">
            {{ item.taxa_conveniencia | moeda }}
          </template>
          <template v-slot:item.taxa_processamento="{ item }">
            {{ item.taxa_processamento | moeda }}
          </template>
          <template v-slot:item.valor_juros="{ item }">
            {{ item.valor_juros | moeda }}
          </template>
          <template v-slot:item.valor_cancelado="{ item }">
            {{ item.valor_cancelado | moeda }}
          </template>
          <template v-slot:item.valor_total="{ item }">
            {{ item.valor_total | moeda }}
          </template>
          <template v-slot:item.comissao="{ item }">
            {{ item.comissao | moeda }}
          </template>
        </v-data-table>
      </CardModule>
      <!-- </div> -->
      <!-- </div> -->
    </AppBody>
  </fragment>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import AppBody from "@/layouts/components/AppBody.vue";
export default {
  name: "Receiveds",
  metaInfo: {
    title: "Relatório Sintético de Recebíveis | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Sintético de Recebíveis | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    AppBody,
  },
  data() {
    return {
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportAction(),
        },
      ],
      dayjs: dayjs,
      activePicker: null,
      date: null,
      menu: false,
      month: "",
      placeholderData: "dd/mm/aa ~ dd/mm/aa",
      headers: [
        {
          text: "Pedido",
          align: "center",
          value: "pedido",
          width: 150,
        },
        {
          text: "Data/Hora do Pedido",
          align: "center",
          value: "data_criacao",
          width: 200,
        },
        {
          text: "Quant. de Itens",
          align: "center",
          value: "qtd_itens_pedido",
          width: 150,
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          width: 130,
        },
        {
          text: "Pessoa",
          align: "center",
          value: "nome",
          width: 140,
        },
        {
          text: "Taxa de Processamento",
          align: "center",
          value: "taxa_processamento",
          width: 200,
        },
        {
          text: "Taxa de Conveniência",
          align: "center",
          value: "taxa_conveniencia",
          width: 200,
        },
        {
          text: "Forma Pgto",
          align: "center",
          value: "form_pag",
          width: 150,
        },
        {
          text: "Valor do Pedido",
          align: "center",
          value: "valor",
          width: 180,
        },
        {
          text: "Valor do Juros",
          align: "center",
          value: "valor_juros",
          width: 180,
        },
        {
          text: "Valor Cancelado",
          align: "center",
          value: "valor_cancelado",
          width: 180,
        },
        {
          text: "Valor Total",
          align: "center",
          value: "valor_total",
          width: 180,
        },
        {
          text: "Valor da Comissão",
          align: "center",
          value: "comissao",
          width: 180,
        },
      ],
      headersTotais: [
        {
          text: "Total de Itens",
          align: "center",
          sortable: false,
          value: "qtd_itens_pedido",
          width: 150,
        },
        {
          text: "Total de Pedidos",
          align: "center",
          sortable: false,
          value: "valor",
          width: 180,
        },
        {
          text: "Total Taxa de Processamento",
          align: "center",
          sortable: false,
          value: "taxa_processamento",
          width: 220,
        },
        {
          text: "Total Taxa de Conveniência",
          align: "center",
          sortable: false,
          value: "taxa_conveniencia",
          width: 220,
        },
        {
          text: "Total de Juros",
          align: "center",
          sortable: false,
          value: "valor_juros",
          width: 180,
        },
        {
          text: "Total Cancelado",
          align: "center",
          sortable: false,
          value: "valor_cancelado",
          width: 180,
        },
        {
          text: "Total de Recebimentos",
          align: "center",
          sortable: false,
          value: "valor_total",
          width: 180,
        },
        {
          text: "Total de Comissões",
          align: "center",
          sortable: false,
          value: "comissao",
          width: 180,
        },
      ],
      recebimentosHeader: [
        {
          title: "Pedido",
          size: "110px",
        },
        {
          title: "Data/Hora do Pedido",
          size: "100px",
        },
        {
          title: "Quant. de Itens",
          size: "60px",
        },
        {
          title: "Status",
          size: "80px",
        },
        {
          title: "Pessoa",
          size: "80px",
        },
        {
          title: "Forma Pgto",
          size: "80px",
        },
        {
          title: "Valor do Pedido",
          size: "100px",
        },
        {
          title: "Valor do Juros",
          size: "100px",
        },
        {
          title: "Valor Total",
          size: "100px",
        },
        {
          title: "Valor da Comissão",
          size: "100px",
        },
      ],
      totaisHeader: [
        {
          title: "-",
          size: "120px",
        },
        {
          title: "-",
          size: "110px",
        },
        {
          title: "Total de Itens",
          size: "72px",
        },
        {
          title: "-",
          size: "87px",
        },
        {
          title: "-",
          size: "89px",
        },
        {
          title: "-",
          size: "90px",
        },
        {
          title: "Total de Pedidos",
          size: "110px",
        },
        {
          title: "Total de Juros",
          size: "112px",
        },
        {
          title: "Total de Recebimentos",
          size: "70px",
        },
        {
          title: "Total de Comissões",
          size: "108px",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["storeSequencial"]),
    tableValues() {
      this.$relatorios_sinteticos.recebimentos.forEach(item => {
        item.pedido = item.pedido ? item.pedido : "-";
        item.qtd_itens_pedido = item.qtd_itens_pedido
          ? item.qtd_itens_pedido
          : "-";
      });

      return this.$relatorios_sinteticos.recebimentos;
    },
    totalTableValues() {
      this.$relatorios_sinteticos.recebimentos_totais.forEach(item => {
        item.qtd_pedido = item.qtd_pedido ? item.qtd_pedido : "-";
        item.qtd_itens_pedido = item.qtd_itens_pedido
          ? item.qtd_itens_pedido
          : "-";
      });

      return this.$relatorios_sinteticos.recebimentos_totais;
    },
    computeRange: {
      get() {
        return this.$relatorios_sinteticos.filter_recebimentos.range_dates;
      },
      set([firstDay]) {
        switch (
          this.$relatorios_sinteticos.filter_recebimentos.intervalo_datas
        ) {
          case "date": {
            // const day = new Date(new Date(firstDay)
            //     .setDate(new Date(firstDay).getDate() + 1))
            //     .toISOString()
            //     .slice(0, 10);
            this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
              firstDay,
              firstDay,
            ];
            break;
          }
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
              currentDayWeek,
              week,
            ];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
              currentDayMonth,
              month,
            ];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
              currentDayCustom,
              custom,
            ];
            // this.$relatorios_sinteticos.filter_recebimentos.range_dates = [firstDay, custom];
            break;
          }
          default: {
            // const defaultCurrentDay = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            const defaultDay = "";
            this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
              firstDay,
              defaultDay,
            ];
            break;
          }
        }
      },
    },
    dateRangeText() {
      let arrayDates = [];
      this.$relatorios_sinteticos.filter_recebimentos.range_dates.forEach(
        item => {
          return arrayDates.push(this.$config.convertDataBR(item));
        }
      );

      return arrayDates.join(" ~ ");
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  watch: {
    "$relatorios_sinteticos.filter_recebimentos.intervalo_datas"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          // const day = new Date(new Date(currentDay).setDate(new Date(currentDay).getDate() + 1)).toISOString().slice(0, 10);
          this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
            currentDay,
            currentDay,
          ];
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
            currentDayWeek,
            week,
          ];
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
            currentDayMonth,
            month,
          ];
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
            currentDayCustom,
            custom,
          ];
          break;
        }
        default: {
          const defaultDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const defaultDayCustom = new Date(
            new Date(defaultDay).setDate(new Date(defaultDay).getDate() + 1)
          )
            .toISOString()
            .slice(0, 10);
          this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
            defaultDay,
            defaultDayCustom,
          ];
          break;
        }
      }
    },
    "$relatorios_sinteticos.filter_recebimentos.tipo_pessoa"(e) {
      this.$relatorios_sinteticos.filter_recebimentos.pessoa = null;
      switch (e) {
        case "idagente":
          this.$pessoas_agentes.getAgentes();
          break;
        case "idponto_venda":
          this.$pointOfSale.getPointsOfSale();
          break;
        case "idloja":
          if (this.$loja_gerenciar.lojas.length == 0) {
            this.$loja_gerenciar.getAllLojas();
          }
          break;
      }
    },
    menu(val) {
      val &&
        setTimeout(() => {
          if (
            val &&
            this.$relatorios_sinteticos.filter_recebimentos.intervalo_datas ==
              "date"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_sinteticos.filter_recebimentos.intervalo_datas ==
              "week"
          ) {
            this.activePicker = "DATE";
          } else if (
            val &&
            this.$relatorios_sinteticos.filter_recebimentos.intervalo_datas ==
              "month"
          ) {
            this.activePicker = "MONTH";
          } else if (
            val &&
            this.$relatorios_sinteticos.filter_recebimentos.intervalo_datas ==
              "custom"
          ) {
            this.activePicker = "DATE";
          } else {
            this.activePicker = "DATE";
          }
        });
    },
    dateRangeText(e) {
      if (e) {
        this.$relatorios_sinteticos.filter_recebimentos.error.range_dates = [];
      }
    },
    "$store.getters.storeSequencial"() {
      this.filterRecebiveis();
    },
  },
  methods: {
    filterRecebiveis() {
      this.$relatorios_sinteticos.filtro("recebimentos", {
        loja: this.storeSequencial,
      });
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    monthEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.$relatorios_sinteticos.filter_recebimentos.range_dates = [
        currentDayMonth,
        monthEnd,
      ];
    },
    exportCSV() {
      this.$relatorios_sinteticos.imprimirCSV("recebimentos");
    },
    exportAction() {
      this.$relatorios_sinteticos.imprimirPDF("recebimentos");
    },
    // exportRecebimentos() {
    //     getExport(this.headers, this.$relatorios_sinteticos.recebimentos, 'recebimentos')
    // },
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.representante_nome.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  mounted() {
    if (this.$loja_gerenciar.lojas.length == 0 && this.isAdmin) {
      this.$loja_gerenciar.getAllLojas();
    }
    if (!this.isAdmin) {
      this.$pointOfSale.getPointsOfSale();
    }
    this.filterRecebiveis();
  },
  destroyed() {
    this.$relatorios_sinteticos.limpaFiltrosRecebimentos();
  },
};
</script>
<style scoped>
.relatorios-container11 {
  display: flex;
  min-height: 140px;
  gap: 1rem;
  flex-wrap: wrap;
}

.resumo-container {
  background-color: #e9e8ed !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.resumo-container:last-child {
  margin-right: 0;
}

.resumo-stat {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  line-height: 1.5;
}

.resumo-text {
  font-size: 1.15rem;
  text-align: center;
}

.resumo-valor {
  color: #572c88;
  font-size: 2.5rem;
}

@media (max-width: 1566px) {
  .resumo-stat {
    width: 80%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
    line-height: 1.5;
  }
}
</style>
